export default __webpack_public_path__ + "static/media/ic_remove.1ab61c60.svg";